import { useCallback } from 'react';

import { LanguageResource } from '@work4all/utils/lib/i18n/LanguageResource.enum';
import deBase from '@work4all/utils/lib/i18n/translation-gen/de/de-base.json';
import deServiceProvider from '@work4all/utils/lib/i18n/translation-gen/de/de-domain-service-provider.json';
import deServiceProviderAndDeliveryNote from '@work4all/utils/lib/i18n/translation-gen/de/de-domain-service-provider-and-delivery-note.json';
import enBase from '@work4all/utils/lib/i18n/translation-gen/en/en-base.json';
import enServiceProvider from '@work4all/utils/lib/i18n/translation-gen/en/en-domain-service-provider.json';
import enServiceProviderAndDeliveryNote from '@work4all/utils/lib/i18n/translation-gen/en/en-domain-service-provider-and-delivery-note.json';
import nlBase from '@work4all/utils/lib/i18n/translation-gen/nl/nl-base.json';
import nlServiceProvider from '@work4all/utils/lib/i18n/translation-gen/nl/nl-domain-service-provider.json';
import nlServiceProviderAndDeliveryNote from '@work4all/utils/lib/i18n/translation-gen/nl/nl-domain-service-provider-and-delivery-note.json';

const TRANSLATIONS = {
  base: {
    en: enBase,
    de: deBase,
    nl: nlBase,
  },

  [LanguageResource.ServiceProvider]: {
    en: enServiceProvider,
    de: deServiceProvider,
    nl: nlServiceProvider,
  },

  [LanguageResource.ServiceProviderAndDeliveryNote]: {
    en: enServiceProviderAndDeliveryNote,
    de: deServiceProviderAndDeliveryNote,
    nl: nlServiceProviderAndDeliveryNote,
  },
};

export const useErpTranslation = (props?: {
  languageResources?: LanguageResource[];
}) => {
  const { languageResources } = props;

  const t = useCallback(
    (
      lang: 'de' | 'en' | 'nl',
      translationKey: string,
      params?: Record<string, string | number>
    ) => {
      let translations = TRANSLATIONS['base'][lang];

      languageResources?.forEach((resource) => {
        const resourceTranslations = TRANSLATIONS[resource] ?? {};

        translations = {
          ...translations,
          ...resourceTranslations,
        };
      });

      let translation = translations[translationKey] || '';

      if (params) {
        Object.keys(params).forEach((key) => {
          translation = translation.replace('{{' + key + '}}', params[key]);
        });
      }

      return translation;
    },
    [languageResources]
  );

  return { t };
};
